import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Form, Row } from 'react-bootstrap';
import { Autocomplete, TextField } from "@mui/material";
import DatePicker from 'react-datepicker';
import Skeleton from 'react-loading-skeleton';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';
import ModalDescargaNotaVenta from '../ModalDescargaNotaVenta';

const FormularioGastoFields = ({
    showModalNuevo,
    Editar,
    cargando,
    formData,
    formErrors,
    handleChange,
    opcionesDescripcion,
    tipoDeGasto,
    cuentasBancarias,
    responsableUsuario,
    formasdePago,
    selectedGasto,
    date,
    handleDateChange,
    setFormErrors,
    GreetingsDateInput,
    notaDeVenta,
    seleccionarArchivoNotaPago,
    setNotaDeVenta
}) => {
    const { token } = useToken();
    const { showErrorToast } = useToast();
    const [showDescargaModal, setShowDescargaModal] = useState(false);

    const descargarNotaDesdeApi = async (idGasto) => {
        setShowDescargaModal(true);
        try {
            const response = await fetch(`/api/Gastos/ObtenerNotaVenta?idGasto=${idGasto}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    const detalles = JSON.parse(data.detalles);
                    const { vNotaVenta_Base64, vNotaVenta_Name } = detalles.table2[0];

                    const byteCharacters = atob(vNotaVenta_Base64);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'application/octet-stream' });

                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = vNotaVenta_Name;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    URL.revokeObjectURL(link.href);
                } else {
                    showErrorToast(data.vMessage || 'Error al obtener nota de venta');
                }
            } else {
                showErrorToast('Error en la petición: ' + response.statusText);
            }
        } catch (error) {
            showErrorToast('Error al descargar nota de venta');
            console.error('Error al descargar nota de venta:', error);
        } finally {
            setShowDescargaModal(false);
        }
    };

    const descargarNotaLocal = (fileObj) => {
        try {
            const link = document.createElement('a');
            const url = URL.createObjectURL(fileObj);
            link.href = url;
            link.download = notaDeVenta.fileName || fileObj.name || 'nota';
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(url);
        } catch (error) {
            showErrorToast('Error al descargar el archivo local');
            console.error(error);
        }
    };

    const handleDownloadClick = () => {
        if (notaDeVenta && notaDeVenta.file && notaDeVenta.fileName) {
            // show modal briefly for local download
            setShowDescargaModal(true);
            try {
                descargarNotaLocal(notaDeVenta.file);
            } finally {
                setTimeout(() => setShowDescargaModal(false), 600);
            }
        } else if (selectedGasto?.bHasNotaVenta === 1) {
            descargarNotaDesdeApi(selectedGasto.idGasto);
        }
    };

    return (
        <Col sm={6} xs={12}>
            {/* Descripción del Gasto */}
            <Row>
                <Col>
                    <Form.Group>
                        <Form.Label>Descripción del Gasto</Form.Label>
                        {showModalNuevo || Editar ? (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Autocomplete
                                        freeSolo
                                        options={opcionesDescripcion}
                                        value={formData.vDescripcion || ""}
                                        onInputChange={(event, newValue) => {
                                            handleChange("vDescripcion", newValue.toUpperCase());
                                        }}
                                        sx={{ width: "100%" }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                size="small"
                                                autoComplete="off"
                                                multiline // 1. Activa el modo multilinea
                                                error={!!formErrors.vDescripcion}
                                                helperText={formErrors.vDescripcion}
                                               
                                            />
                                        )}
                                    />
                                )}
                            </>
                        ) : (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        value={selectedGasto?.vDescripcion || ""}
                                        readOnly
                                    />
                                )}
                            </>
                        )}
                    </Form.Group>
                </Col>
            </Row>

            {/* Tipo de Gasto */}
            <Row>
                <Col>
                    <Form.Group>
                        <Form.Label>Tipo de Gasto</Form.Label>
                        {showModalNuevo || Editar ? (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Select
                                        size="sm"
                                        value={formData.idTipoGasto || ""}
                                        onChange={(e) => handleChange("idTipoGasto", e.target.value)}
                                        isInvalid={!!formErrors.idTipoGasto}
                                    >
                                        <option value="">Selecciona un tipo de Gasto</option>
                                        {tipoDeGasto.map((tipo, index) => (
                                            <option key={index} value={tipo.idTipoGasto}>
                                                {`${tipo.vNombre}`}
                                            </option>
                                        ))}
                                    </Form.Select>
                                )}
                            </>
                        ) : (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        value={selectedGasto?.vTipoGasto || ""}
                                        readOnly
                                    />
                                )}
                            </>
                        )}
                        <Form.Control.Feedback type="invalid">
                            {formErrors.idTipoGasto}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>

            {/* Cuenta Bancaria */}
            <Row>
                <Col className="mb-sm-2">
                    <Form.Group>
                        <Form.Label>Cuenta Bancaria</Form.Label>
                        {showModalNuevo || Editar ? (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Select
                                        size="sm"
                                        isInvalid={!!formErrors.idCatCuentaBancaria}
                                        value={formData.idCatCuentaBancaria || ""}
                                        onChange={(e) => handleChange("idCatCuentaBancaria", e.target.value)}
                                    >
                                        <option value="">Selecciona una cuenta bancaria</option>
                                        {cuentasBancarias.map((cuenta, index) => (
                                            <option key={index} value={cuenta.idCatCuentaBancaria}>
                                                {`${cuenta.vNumCta} - ${cuenta.vNombreBanco} - ${cuenta.vNombreTitular}`}
                                            </option>
                                        ))}
                                    </Form.Select>
                                )}
                            </>
                        ) : (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        value={selectedGasto?.DetallesCuenta || ""}
                                        readOnly
                                    />
                                )}
                            </>
                        )}
                        <Form.Control.Feedback type="invalid">
                            {formErrors.idCatCuentaBancaria}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>

            {/* Responsable del Gasto */}
            <Row>
                <Col lg={12} md={12} sm={6}>
                    <Form.Group>
                        <Form.Label>Responsable del Gasto</Form.Label>
                        {showModalNuevo || Editar ? (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Select
                                        size="sm"
                                        isInvalid={!!formErrors.idUsuario}
                                        value={formData.idUsuario || ""}
                                        onChange={(e) => handleChange("idUsuario", e.target.value)}
                                    >
                                        <option value="">Seleccione un responsable</option>
                                        {responsableUsuario.map((usuario, index) => (
                                            <option key={index} value={usuario.idUsuario}>
                                                {`${usuario.vNombre} ${usuario.vApellidos}`}
                                            </option>
                                        ))}
                                    </Form.Select>
                                )}
                            </>
                        ) : (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        value={selectedGasto?.vResponsable || ""}
                                        readOnly
                                    />
                                )}
                            </>
                        )}
                        <Form.Control.Feedback type="invalid">
                            {formErrors.idUsuario}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>

                {/* Forma de Pago */}
                <Col lg={12} md={12} sm={6}>
                    <Form.Group>
                        <Form.Label>Forma de Pago</Form.Label>
                        {showModalNuevo || Editar ? (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Select
                                        size="sm"
                                        isInvalid={!!formErrors.idCatFormaPago}
                                        value={formData.idCatFormaPago || ""}
                                        onChange={(e) => handleChange("idCatFormaPago", e.target.value)}
                                    >
                                        <option value="">Seleccione una forma de Pago</option>
                                        {formasdePago.map((pago, index) => (
                                            <option key={index} value={pago.idCatFormaPago}>
                                                {pago.vClave} - {pago.vDescripcionFormaPago}
                                            </option>
                                        ))}
                                    </Form.Select>
                                )}
                            </>
                        ) : (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        value={selectedGasto?.vFormaPago || ""}
                                        readOnly
                                    />
                                )}
                            </>
                        )}
                        <Form.Control.Feedback type="invalid">
                            {formErrors.idCatFormaPago}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>

            {/* Fecha de Gasto */}
            <Row>
                <Col lg={12} md={12} sm={12} xs={6} className="mt-2 mt-sm-0">
                    <Form.Group>
                        <Form.Label>Fecha de Gasto</Form.Label>
                        {showModalNuevo || Editar ? (
                            <Col>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <DatePicker
                                            selected={date}
                                            onChange={(date) => {
                                                handleDateChange(date);
                                                if (formErrors.date) {
                                                    setFormErrors((prevErrors) => ({ ...prevErrors, date: null }));
                                                }
                                            }}
                                            dateFormat="dd MMM yyyy"
                                            showYearDropdown
                                            showMonthDropdown
                                            dropdownMode="select"
                                            yearDropdownItemNumber={15}
                                            scrollableYearDropdown
                                            customInput={<GreetingsDateInput />}
                                            popperModifiers={[
                                                {
                                                    name: "preventOverflow",
                                                    options: { boundary: "viewport" },
                                                },
                                                {
                                                    name: "offset",
                                                    options: { offset: [0, -290] },
                                                },
                                            ]}
                                            style={{
                                                borderColor: formErrors.date ? '#dc3545' : 'initial',
                                                borderWidth: '2px',
                                                borderStyle: 'solid',
                                                padding: '5px',
                                                borderRadius: '4px'
                                            }}
                                        />
                                        {formErrors.date && (
                                            <span style={{ color: '#dc3545', fontSize: '12px', marginTop: '4px' }}>
                                                {formErrors.date}
                                            </span>
                                        )}
                                    </div>
                                )}
                            </Col>
                        ) : (
                            <>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        value={
                                            selectedGasto?.dFechaGasto
                                                ? new Date(selectedGasto.dFechaGasto).toLocaleDateString("es-MX", {
                                                    day: "2-digit",
                                                    month: "short",
                                                    year: "numeric",
                                                }).replace(/(?:^|\s)([a-z])/g, char => char.toUpperCase())
                                                : ""
                                        }
                                        readOnly
                                    />
                                )}
                            </>
                        )}
                    </Form.Group>
                </Col>

                {/* Nota de Venta o Factura Recibida */}
                <Col lg={12} md={12} sm={12} xs={6} className="mt-md-2 mb-3 mt-2">
                    <Form.Group>
                        {selectedGasto?.idFacturaRecibida && selectedGasto.idFacturaRecibida !== 0 ? (
                            <>
                                <Form.Label>Factura Recibida</Form.Label>
                                {cargando ? (
                                    <Skeleton />
                                ) : (
                                    <div className="d-flex align-items-center border rounded p-2 bg-light">
                                        <a
                                            href={`/contabilidad/facturacion/facturas-recibidas/visualizacion/${selectedGasto.idFacturaRecibida}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-decoration-none"
                                        >
                                            <span style={{ fontSize: '1.2rem' }}>📄</span> Ver Factura Recibida
                                        </a>
                                    </div>
                                )}
                            </>
                        ) : (
                            <>
                                <Form.Label>Nota de Venta (Opcional)</Form.Label>
                                {showModalNuevo || Editar ? (
                                    <>
                                        {cargando ? (
                                            <Skeleton />
                                        ) : (
                                            <>
                                                {/* Display filename / status in its own full-width row */}
                                                <div className="mb-2">
                                                    <div className="input-group" style={{ height: '36px' }}>
                                                        <span className="input-group-text bg-light" style={{ borderRight: '0' }}>
                                                            <span style={{ fontSize: '1rem' }}>📎</span>
                                                        </span>
                                                        <div
                                                            className="form-control text-truncate d-flex align-items-center bg-light"
                                                            style={{ cursor: (notaDeVenta?.fileName || selectedGasto?.bHasNotaVenta === 1) ? 'pointer' : 'default', borderLeft: '0' }}
                                                            onClick={handleDownloadClick}
                                                            title={(notaDeVenta?.fileName || selectedGasto?.bHasNotaVenta === 1) ? 'Clic para descargar nota de venta' : ''}
                                                        >
                                                            <span className="small">
                                                                {notaDeVenta?.fileName
                                                                    ? notaDeVenta.fileName
                                                                    : (selectedGasto?.bHasNotaVenta === 1
                                                                        ? "Nota de venta guardada"
                                                                        : "Ningún archivo seleccionado")}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Buttons in a separate row for better layout */}
                                                <Row className="g-2 align-items-center">
                                                    <Col xs={6} sm={6} md={6} lg={6} className="p-0">
                                                        <Form.Control
                                                            type="file"
                                                            onChange={(e) => {
                                                                seleccionarArchivoNotaPago(e);
                                                                e.target.value = "";
                                                            }}
                                                            style={{ display: "none" }}
                                                            id="fileUpload_cer"
                                                        />
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-secondary btn-sm w-100 text-truncate"
                                                            onClick={() => document.getElementById("fileUpload_cer").click()}
                                                            style={{ height: '34px' }}
                                                            title="Seleccionar archivo"
                                                        >
                                                            <span className="small">Seleccionar archivo</span>
                                                        </button>
                                                    </Col>

                                                    <Col xs={6} sm={6} md={6} lg={6} className="p-0">
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger btn-sm w-100"
                                                            onClick={() => {
                                                                setNotaDeVenta({ fileName: "", file: "" });
                                                                const input = document.getElementById("fileUpload_cer");
                                                                if (input) input.value = "";
                                                            }}
                                                            style={{ height: '34px' }}
                                                            title="Eliminar archivo"
                                                        >
                                                            <span className="small">Eliminar</span>
                                                        </button>
                                                    </Col>

                                                    <Col xs={12} className="mt-1 px-0">
                                                        <small className="text-muted">Formatos permitidos: PDF, PNG, JPG. Tamaño máximo: 5MB.</small>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        {cargando ? (
                                            <Skeleton />
                                        ) : (
                                            <>
                                                {selectedGasto?.bHasNotaVenta === 1 ? (
                                                    <div className="d-flex align-items-center border rounded p-2 bg-light" style={{ cursor: 'pointer' }} onClick={() => { setShowDescargaModal(true); descargarNotaDesdeApi(selectedGasto.idGasto); }}>
                                                        <span style={{ fontSize: '1.2rem' }}>📎</span>
                                                        <span className="ms-2 small">Nota de venta disponible</span>
                                                    </div>
                                                ) : (
                                                    <Form.Control
                                                        size="sm"
                                                        type="text"
                                                        value={"No existe Nota de Venta"}
                                                        readOnly
                                                    />
                                                )}
                                            </>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                    </Form.Group>
                </Col>
            </Row>

            <ModalDescargaNotaVenta show={showDescargaModal} />
        </Col>
    );
};

FormularioGastoFields.propTypes = {
    showModalNuevo: PropTypes.bool,
    Editar: PropTypes.bool,
    cargando: PropTypes.bool,
    formData: PropTypes.object.isRequired,
    formErrors: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    opcionesDescripcion: PropTypes.array,
    tipoDeGasto: PropTypes.array,
    cuentasBancarias: PropTypes.array,
    responsableUsuario: PropTypes.array,
    formasdePago: PropTypes.array,
    selectedGasto: PropTypes.object,
    date: PropTypes.instanceOf(Date),
    handleDateChange: PropTypes.func.isRequired,
    setFormErrors: PropTypes.func.isRequired,
    GreetingsDateInput: PropTypes.elementType.isRequired,
    notaDeVenta: PropTypes.object.isRequired,
    seleccionarArchivoNotaPago: PropTypes.func.isRequired,
    setNotaDeVenta: PropTypes.func.isRequired
};

export default FormularioGastoFields;
